import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import styles from "../agent-response.module.scss";

type ResumeFetcherAgentProps = {
  parsedContent: any;
};

export default function ResumeFetcherAgent({
  parsedContent,
}: ResumeFetcherAgentProps): JSX.Element {
  const answer = safeJSONParse(parsedContent?.answer);
  const question = parsedContent?.question;
  console.log("HR AGENT ANSWER", answer);
  return (
    <div
      style={{
        color: "#333",
        width: "100%",
        overflowX: "auto",
      }}
    >
      <div className={styles.finalQuestion} style={{ border: "none" }}>
        {answer.candidates && answer.candidates.length > 0
          ? `A total of ${answer.candidates.length} qualified candidates have been identified. In the next step, the top 5 will be presented.`
          : question}
      </div>
    </div>
  );
}
